import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/components/lobby-games/lode-nodata.png")